import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { Eye } from "lucide-react";

export default function Tafsir() {
  const { t } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => { getContent("tafsir").then(setItems); }, []);

  return (
    <div className="space-y-6 fade-in" data-testid="tafsir-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Eye className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.tafsir}</h1>
          <p className="text-sm text-nour-text2">Explications de versets essentiels</p>
        </div>
      </header>

      <div className="space-y-4" data-testid="tafsir-list">
        {items.map(it => (
          <article key={it.id} className="nour-card p-6" data-testid={`tafsir-${it.id}`}>
            <div className="text-xs uppercase tracking-wider text-nour-text2">{it.surah}</div>
            <div className="font-arabic-quran text-2xl text-right text-nour-primary my-3" dir="rtl">{it.ar}</div>
            <p className="text-base text-nour-text">{it.fr_verse}</p>
            <div className="mt-4 nour-card p-4 bg-emerald-50">
              <div className="text-xs uppercase tracking-wider text-nour-text2 mb-1">{t.context}</div>
              <p className="text-sm">{it.context_fr}</p>
            </div>
            <div className="mt-3 nour-card p-4 bg-amber-50">
              <div className="text-xs uppercase tracking-wider text-nour-text2 mb-1">{t.explanation}</div>
              <p className="text-sm leading-relaxed">{it.tafsir_fr}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
